import { useTranslation } from 'react-i18next';
import { PRODUCT_TYPES } from '@schuettflix/interfaces';
import { ChevronDownIcon } from '@schuettflix/planum-icons-react';
import { PRODUCT_NAME_LABEL } from '@/phrase/ProductNameLabels';

type ProductSelectionProps = {
    dealLineItemId: string;
    options: PRODUCT_TYPES[];
    value: PRODUCT_TYPES | null;
    disabled?: boolean;
    onChange: (value: PRODUCT_TYPES | null) => void;
};

const ENHANCED_PRODUCT_NAMES = {
    ...PRODUCT_NAME_LABEL,
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING:
        'salesforceDealImporter.dealLineItemRow.productType.nonHazardousWasteRecycling',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'salesforceDealImporter.dealLineItemRow.productType.nonHazardousWasteDisposal',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'salesforceDealImporter.dealLineItemRow.productType.hazardousWasteRecycling',
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'salesforceDealImporter.dealLineItemRow.productType.hazardousWasteDisposal',
} as const;

export function ProductTypeSelection({ dealLineItemId, options, value, onChange, disabled }: ProductSelectionProps) {
    const { t } = useTranslation();

    return (
        <div className="bg-surface hover:border-hovered focus-within:border-focused relative h-12 w-full max-w-[152px] rounded border">
            <div className="absolute right-0 top-0 flex h-12 items-center pr-4">
                <ChevronDownIcon />
            </div>
            <select
                className="font-copy-md h-full w-full appearance-none truncate bg-transparent pl-4 pr-8 outline-none"
                disabled={disabled}
                name={`product-select-${dealLineItemId}`}
                defaultValue={'null'}
                data-test={`product-select-${dealLineItemId}`}
                value={value ?? 'null'}
                onChange={e => {
                    const value = e.target.value as PRODUCT_TYPES;
                    onChange(value);
                }}
            >
                <option value="null" disabled>
                    {t('salesforceDealImporter.dealLineItemRow.productTypeSelection.label')}
                </option>
                {options.map(option => (
                    <option key={option} value={option}>
                        {t(ENHANCED_PRODUCT_NAMES[option])}
                    </option>
                ))}
            </select>
        </div>
    );
}
